import { render, staticRenderFns } from "./CompanyManagement.vue?vue&type=template&id=736556f5&scoped=true"
import script from "./CompanyManagement.vue?vue&type=script&lang=js"
export * from "./CompanyManagement.vue?vue&type=script&lang=js"
import style0 from "./CompanyManagement.vue?vue&type=style&index=0&id=736556f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736556f5",
  null
  
)

export default component.exports